import React from 'react';

// ui
import { SvgIcon, SvgIconProps } from '@domonda/ui/SvgIcon';

// icons
import CheckmarkIconSvg from './checkmarkIco.svg';
import CheckmarkSomeIconSvg from './checkmarkSomeIco.svg';
import UpdateNotesIconSvg from './updateNotesIco.svg';
import HelpIconSvg from './helpIco.svg';
import DeleteIconSvg from './deleteIco.svg';
import UploadDocumentsIconSvg from './uploadDocumentsIco.svg';

export const CheckmarkSomeIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: CheckmarkSomeIconSvg }} />
  </SvgIcon>
);

export const CheckmarkIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: CheckmarkIconSvg }} />
  </SvgIcon>
);

export const UpdateNotesIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: UpdateNotesIconSvg }} />
  </SvgIcon>
);

export const HelpIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: HelpIconSvg }} />
  </SvgIcon>
);

export const DeleteIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: DeleteIconSvg }} />
  </SvgIcon>
);

export const UploadDocumentsIcon: React.FC<SvgIconProps> = ({ children, ...rest }) => (
  <SvgIcon {...rest}>
    <g dangerouslySetInnerHTML={{ __html: UploadDocumentsIconSvg }} />
  </SvgIcon>
);
